import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Select from "react-select";
import * as constantMessages from "../../constants/constatntMessages";
import { Popover, OverlayTrigger, Accordion } from "react-bootstrap";
import { convertFirstLetterOfFullNameToCapital } from "../../helpers/commonHelpers";

import LoaderButton from "../Common/LoaderButton";
import { sendActionNotification } from "../../redux/actions/actionAction/ActionAction";
import SmallLoaderButton from "../Common/SmallLoaderButton";
import AgendaAccordianHeader from "../Common/AgendaAccordianHeader";
import NotifyActionAccordianHeader from "../Common/NotifyActionAccordianHeader";

const ActionNotifyModal = (props) => {
  const dispatch = useDispatch();
  const accessToken = localStorage.getItem("accessToken");
  const { agendaData, meetingData } = props;
  let actionArray = [];
  agendaData?.map((agenda) => {
    const onlyActions = agenda?.minutesDetail?.filter(
      (item) => item.isActive === true && item.isAction === true
    );
    if (onlyActions?.length !== 0) {
      actionArray = [...actionArray, ...onlyActions];
    }
  });
  const [selectedOption, setSelectedOption] = useState([
    { label: "Select Attendee(s)", value: "" },
  ]);

  const [actionsFinalArray, setActionsFinalArray] = useState([]);
  const [loading, setLoading] = useState(false);
  const actionData = useSelector((state) => state.action);
  useEffect(() => {
    if (actionData?.isSuccess === true && actionData?.updateLoading === false) {
      props.setIsActionsForNotifyModal(false);
      setActionsFinalArray([]);
    }

    return () => {
      // Anything in here is fired on component unmount.
    };
  }, [actionData?.isSuccess]);

  const handleSubmit = async () => {
    if (actionsFinalArray.length === 0) {
      toast.warning(constantMessages.selectAction, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      const payload = {
        meetingId: meetingData?.meetingDetails?._id,
        actionIds: actionsFinalArray,
      };
      setLoading(true);
      await dispatch(sendActionNotification(payload, accessToken));
      setLoading(false);
    }
  };

  const checkHandler = (e, actionId) => {
    if (actionId === "all") {
      setSelectedOption([{ label: "Select Attendee(s)", value: "" }]);
      if (actionArray.length === actionsFinalArray.length) {
        setActionsFinalArray([]);
      } else {
        const modifiedActions = actionArray.map((obj) => {
          return obj._id;
        });
        setActionsFinalArray([...modifiedActions]);
      }
    } else {
      if (actionId) {
        if (actionsFinalArray.includes(actionId)) {
          const modifiedActions = actionsFinalArray.filter(
            (item) => item !== actionId
          );
          setActionsFinalArray([...modifiedActions]);
        } else {
          setActionsFinalArray([...actionsFinalArray, actionId]);
        }
      }
    }
  };

  const popoverHoverFocus = (title) => {
    return (
      <Popover id="popover-basic" className="custom-popover">
        <Popover.Body className="popover-body">{title}</Popover.Body>
      </Popover>
    );
  };
  let attendeesOptions = null;

  let attendeesArray =
    agendaData?.flatMap((agenda) =>
      agenda?.minutesDetail
        ?.filter((minute) => minute?.isActive && minute?.isAction)
        ?.flatMap((action) => action?.assignedUsersDetails || [])
    ) || [];

  // Remove duplicates based on _id
  attendeesArray = [
    ...new Map(attendeesArray.map((user) => [user?._id, user])).values(),
  ];

 

  if (attendeesArray?.length !== 0) {
    attendeesOptions = attendeesArray.map((attendee) => ({
      value: attendee?._id,
      label: attendee?.name,
      name: "attendeeId",
    }));
  }

  const handleAttendeesChange = (e) => {
    const { value, label } = e;

 const assignedUserSelectedActionIds =
      actionArray
        ?.filter(({ assignedUserId }) => assignedUserId.includes(value))
        .map(({ _id }) => _id) ?? [];
    setActionsFinalArray(assignedUserSelectedActionIds);
    setSelectedOption(e);
  };

  const handleReset = (e) => {
    e.preventDefault(e);
    setSelectedOption([{ label: "Select Attendee(s)", value: "" }]);
    setActionsFinalArray([]);
  };
  return (
    <Modal
      className="notify-modal"
      show={props.IsActionsForNotifyModal}
      onHide={(e) => props.setIsActionsForNotifyModal(false)}
      size="lg"
      backdrop="static"
    >
      <Modal.Dialog>
        <div className="modal-header attendees-modal">
          <div>
            <h4 className="modal-title">Notify Actions</h4>
          </div>
          <div>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={(e) => {
                props.setIsActionsForNotifyModal(false);
                setActionsFinalArray([]);
                setSelectedOption([{ label: "Select Attendee(s)", value: "" }]);
              }}
            ></button>
          </div>
        </div>

        <Modal.Body className="attendees-popup modal-margin notify-modal-popup">
          <div className="check-attendee justify-content-between notify-modal">
            <div className="notifyaction-modal-checkattendee-right d-flex gap-2 align-items-center mb-2">
              <label>Attendee(s)</label>

              <Select
                className="width-50 fltr-opt mt-0"
                placeholder="Select Attendees"
                name="attendeeId"
                options={attendeesOptions ? attendeesOptions : null}
                onChange={handleAttendeesChange}
                value={selectedOption}
              />
            </div>
          </div>
          <div className="notifyaction-modal-checkattendee-left d-flex gap-2 align-items-center me-1 mt-3 justify-content-start">
            <input
              type="checkbox"
              name="selectedAttendee"
              id=""
              className="form-check-input"
              onChange={(e) => checkHandler(e, "all")}
              checked={
                actionsFinalArray?.length === actionArray?.length ? true : false
              }
            />
            <label>Select All</label>
          </div>
          {agendaData?.length !== 0 &&
            agendaData?.map((agenda, index) => {
              return (
                <Accordion defaultActiveKey="0">
                  <div className="mt-3 agenda-box-border new-notify-action-modal">
                    <Accordion.Item
                      eventKey={index.toString()}
                      className="agenda-accordion "
                    >
                      <NotifyActionAccordianHeader
                        agenda={agenda}
                        index={index}
                      />

                      <Accordion.Body>
                        <div className="">
                          <div className="form-group padding-left60">
                            <div className="row">
                              <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                                <label className="">Agenda Title</label>
                              </div>
                              <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                                <p>{agenda.title}</p>
                              </div>
                            </div>
                          </div>

                          {agenda?.minutesDetail?.filter(
                            (item) => item.isActive === true
                          ).length !== 0 ? (
                            <>
                              <div></div>
                              <div className="minutes-border"></div>

                              {agenda?.minutesDetail?.filter(
                                (item) => item.isActive === true
                              ).length !== 0 &&
                                agenda?.minutesDetail
                                  ?.filter(
                                    (item) =>
                                      item.isActive === true &&
                                      item.isAction === true
                                  )
                                  .map((minute, index) => {
                                    return (
                                      <>
                                        <div className="notify-action-modal-body d-flex gap-2">
                                          <div className="agenda-minutes agenda-input-box">
                                            <div className="check-attendee align-items-center">
                                              <input
                                                type="checkbox"
                                                name="selectedAttendee"
                                                id=""
                                                className="form-check-input"
                                                onChange={(e) =>
                                                  checkHandler(e, minute._id)
                                                }
                                                checked={
                                                  actionsFinalArray.includes(
                                                    minute?._id?.toString()
                                                  )
                                                    ? true
                                                    : false
                                                }
                                              />
                                            </div>
                                            <div className="padding-left10 w-100">
                                              <div className="form-group ">
                                                <div className="row">
                                                  <div className="col-md-4">
                                                    <label className="">
                                                      Action {index + 1}
                                                    </label>
                                                  </div>
                                                  <div className="col-md-8">
                                                    <p> {minute?.title}</p>
                                                  </div>
                                                </div>
                                              </div>

                                              {minute.isAction ? (
                                                <>
                                                  {minute?.isAction ? (
                                                    <div className="form-group">
                                                      <div className="row">
                                                        <div className="col-md-4">
                                                          <label className="">
                                                            Responsible Person
                                                          </label>
                                                        </div>
                                                        <div className="col-md-8">
                                                          {minute
                                                            ?.assignedUsersDetails
                                                            ?.length > 0 && (
                                                            <div>
                                                              {minute.assignedUsersDetails.map(
                                                                (
                                                                  user,
                                                                  index
                                                                ) =>
                                                                  user?.name ? (
                                                                    <div
                                                                      key={
                                                                        index
                                                                      }
                                                                    >
                                                                      {convertFirstLetterOfFullNameToCapital(
                                                                        user.name
                                                                      )}
                                                                      {""} / {""}
                                                                      {
                                                                        user.email
                                                                      }
                                                                    </div>
                                                                  ) : null
                                                              )}
                                                            </div>
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  ) : null}
                                                </>
                                              ) : null}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="minutes-border"></div>
                                      </>
                                    );
                                  })}
                            </>
                          ) : null}
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </div>
                </Accordion>
              );
            })}
        </Modal.Body>
      </Modal.Dialog>
      <div className="modal-footer">
        <button className="add-btn Mom-btn" type="reset" onClick={handleReset}>
          <p>Reset</p>
        </button>

        {loading ? (
          <SmallLoaderButton />
        ) : (
          <button
            type="button"
            onClick={handleSubmit}
            className="Mom-btn btn btn-secondary bg-primary border-primary"
          >
            <p>Send</p>
          </button>
        )}
      </div>
    </Modal>
  );
};

export default ActionNotifyModal;
